var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { WmDateRange, WmInput } from "@watermarkinsights/ripple-react";
import { forwardRef, useEffect, useImperativeHandle, useReducer } from "react";
import { useIntl } from "react-intl";
import { sendRequestWithPayload, sendRequest } from "src/common/http";
import { formatDateUsToIso } from "src/features/common/helper";
var defaultFieldsErrorMessages = {
    titleError: "",
    codeError: "",
    startDateError: "",
    endDateError: ""
};
var initialState = {
    reportingYearFields: {
        title: "",
        code: "",
        startDate: "",
        endDate: "",
        reportingYearType: "academic"
    },
    fieldsErrorMessages: defaultFieldsErrorMessages,
    token: ""
};
var defaultAction = {
    type: "",
    title: "",
    titleError: "",
    code: "",
    codeError: "",
    startDate: "",
    startDateError: "",
    endDate: "",
    endDateError: "",
    token: "",
    updateReportingYear: null
};
var formatDateIsoToUs = function (date) {
    if (!date)
        return "";
    // Check if already in US format (mm/dd/yyyy) - must not contain time component
    if (date.includes("/") && !date.includes("T"))
        return date;
    // Strip time component if present (e.g., "2024-01-01T00:00:00" -> "2024-01-01")
    var dateOnly = date.split("T")[0];
    // If it's already in US format after stripping time, return it
    if (dateOnly.includes("/"))
        return dateOnly;
    // Only convert if it's a valid ISO format (yyyy-mm-dd) with exactly 3 parts
    var d = dateOnly.split("-");
    if (d.length !== 3) {
        // Not a valid ISO date format, return as-is (user is still typing)
        return date;
    }
    // Convert from ISO format (yyyy-mm-dd) to US format (mm/dd/yyyy)
    return d[1] + "/" + d[2] + "/" + d[0];
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setTitle":
            return __assign(__assign({}, state), { reportingYearFields: __assign(__assign({}, state.reportingYearFields), { title: action.title }), fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { titleError: "" }) });
        case "setTitleError":
            return __assign(__assign({}, state), { fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { titleError: action.titleError }) });
        case "setCode":
            return __assign(__assign({}, state), { reportingYearFields: __assign(__assign({}, state.reportingYearFields), { code: action.code }), fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { codeError: "" }) });
        case "setCodeError":
            return __assign(__assign({}, state), { fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { codeError: action.codeError }) });
        case "setStartDate":
            return __assign(__assign({}, state), { reportingYearFields: __assign(__assign({}, state.reportingYearFields), { startDate: action.startDate }), fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { startDateError: "" }) });
        case "setStartDateError":
            return __assign(__assign({}, state), { fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { startDateError: action.startDateError }) });
        case "setEndDate":
            return __assign(__assign({}, state), { reportingYearFields: __assign(__assign({}, state.reportingYearFields), { endDate: action.endDate }), fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { endDateError: "" }) });
        case "setEndDateError":
            return __assign(__assign({}, state), { fieldsErrorMessages: __assign(__assign({}, state.fieldsErrorMessages), { endDateError: action.endDateError }) });
        case "resetFormInputs":
            return {
                reportingYearFields: {
                    title: "",
                    code: "",
                    startDate: "",
                    endDate: ""
                },
                fieldsErrorMessages: {
                    titleError: "",
                    codeError: "",
                    startDateError: "",
                    endDateError: ""
                }
            };
        case "setReportingYearFields":
            return {
                reportingYearFields: {
                    title: action.updateReportingYear
                        ? action.updateReportingYear.name
                        : "",
                    code: action.updateReportingYear
                        ? action.updateReportingYear.code
                        : "",
                    startDate: action.updateReportingYear
                        ? formatDateIsoToUs(action.updateReportingYear.startDate)
                        : "",
                    endDate: action.updateReportingYear
                        ? formatDateIsoToUs(action.updateReportingYear.endDate)
                        : ""
                },
                fieldsErrorMessages: {
                    titleError: "",
                    codeError: "",
                    startDateError: "",
                    endDateError: ""
                }
            };
        case "setToken":
            return __assign(__assign({}, state), { token: action.token });
        default:
            return state;
    }
};
var CreateReportingYearForm = forwardRef(function (_a, ref) {
    var reportingYears = _a.reportingYears, openReportingYearModalState = _a.openReportingYearModalState, closeReportingYearModal = _a.closeReportingYearModal, fetchReportingYears = _a.fetchReportingYears, updateReportingYear = _a.updateReportingYear, addSnackBar = _a.addSnackBar;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    useImperativeHandle(ref, function () { return ({
        getCsrfToken: getCsrfToken
    }); });
    var reportingYearFields = state.reportingYearFields, fieldsErrorMessages = state.fieldsErrorMessages;
    var titleLabel = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.titleLabel"
    });
    var startDateLabel = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.startDateLabel"
    });
    var endDateLabel = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.endDateLabel"
    });
    var codeLabel = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.codeLabel"
    });
    var titleInfo = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.titleInfo"
    });
    var codeInfo = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.codeInfo"
    });
    var titleRequired = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.titleRequired"
    });
    var uniqueTitle = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.uniqueTitle"
    });
    var codeRequired = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.codeRequired"
    });
    var uniqueCode = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.uniqueCode"
    });
    var dateRequired = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.dateRequired"
    });
    var invalidDate = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.invalidDate"
    });
    var overlappedDateError = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.overlappedDateError"
    });
    var startDateGreater = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.startDateGreater"
    });
    var endDateLesser = useIntl().formatMessage({
        id: "app.settings.reportingYearForm.endDateLesser"
    });
    var handleTitleChange = function (event) {
        dispatch(__assign(__assign({}, defaultAction), { type: "setTitle", title: event.target.value }));
    };
    var handleCodeChange = function (event) {
        dispatch(__assign(__assign({}, defaultAction), { type: "setCode", code: event.target.value }));
    };
    var handleRangeSelection = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var dateRange, _a, startDate, endDate, formattedStartDate, formattedEndDate;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dateRange = event.target;
                    _a = event.detail, startDate = _a.startDate, endDate = _a.endDate;
                    resetOverlappedEndDateError();
                    resetOverlappedStartDateError();
                    return [4 /*yield*/, dateRange.reformatDate("ISO", "US", startDate.iso)];
                case 1:
                    formattedStartDate = _b.sent();
                    return [4 /*yield*/, dateRange.reformatDate("ISO", "US", endDate.iso)];
                case 2:
                    formattedEndDate = _b.sent();
                    dispatch(__assign(__assign({}, defaultAction), { type: "setStartDate", startDate: formattedStartDate }));
                    dispatch(__assign(__assign({}, defaultAction), { type: "setEndDate", endDate: formattedEndDate }));
                    // Validate the range after both dates are set
                    validateReportingYearStartDate(formattedStartDate, formattedEndDate);
                    validateReportingYearEndDate(formattedEndDate, formattedStartDate);
                    return [2 /*return*/];
            }
        });
    }); };
    function validateReportingYearTitle(title) {
        if (title.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setTitleError", titleError: titleRequired }));
        }
        else {
            var isDuplicate = reportingYears === null || reportingYears === void 0 ? void 0 : reportingYears.filter(function (year) { return year.uuid !== (updateReportingYear === null || updateReportingYear === void 0 ? void 0 : updateReportingYear.uuid); }).some(function (item) {
                return item.name.toUpperCase().trim() === title.toUpperCase().trim();
            });
            if (isDuplicate) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setTitleError", titleError: uniqueTitle }));
            }
        }
    }
    function validateReportingYearCode(code) {
        if (code.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setCodeError", codeError: codeRequired }));
        }
        else {
            var isDuplicate = reportingYears === null || reportingYears === void 0 ? void 0 : reportingYears.filter(function (year) { return year.uuid !== (updateReportingYear === null || updateReportingYear === void 0 ? void 0 : updateReportingYear.uuid); }).some(function (item) {
                return item.code.toUpperCase().trim() === code.toUpperCase().trim();
            });
            if (isDuplicate) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setCodeError", codeError: uniqueCode }));
            }
        }
    }
    function validateReportingYearStartDate(startDate, endDate) {
        if (fieldsErrorMessages.endDateError === endDateLesser) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: "" }));
        }
        if (startDate.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: dateRequired }));
        }
        else if (!isValidDateFormat(startDate)) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: invalidDate }));
        }
        else if (startDate &&
            endDate &&
            isValidDateFormat(endDate) &&
            isValidDateFormat(startDate) &&
            new Date(startDate) >= new Date(endDate)) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: startDateGreater }));
        }
        else if (startDate &&
            endDate &&
            isValidDateFormat(endDate) &&
            isValidDateFormat(startDate) &&
            (reportingYears === null || reportingYears === void 0 ? void 0 : reportingYears.filter(function (year) { return year.uuid !== (updateReportingYear === null || updateReportingYear === void 0 ? void 0 : updateReportingYear.uuid); }).some(function (year) {
                return isDateRangeOverlap(year.startDate, year.endDate, startDate, endDate);
            }))) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: overlappedDateError }));
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: overlappedDateError }));
        }
    }
    function validateReportingYearEndDate(endDate, startDate) {
        if (fieldsErrorMessages.startDateError === startDateGreater) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: "" }));
        }
        if (endDate.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: dateRequired }));
        }
        else if (!isValidDateFormat(endDate)) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: invalidDate }));
        }
        else if (startDate &&
            endDate &&
            isValidDateFormat(endDate) &&
            isValidDateFormat(startDate) &&
            new Date(startDate) >= new Date(endDate)) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: endDateLesser }));
        }
        else if (startDate &&
            endDate &&
            isValidDateFormat(endDate) &&
            isValidDateFormat(startDate) &&
            (reportingYears === null || reportingYears === void 0 ? void 0 : reportingYears.filter(function (year) { return year.uuid !== (updateReportingYear === null || updateReportingYear === void 0 ? void 0 : updateReportingYear.uuid); }).some(function (year) {
                return isDateRangeOverlap(year.startDate, year.endDate, startDate, endDate);
            }))) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: overlappedDateError }));
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: overlappedDateError }));
        }
    }
    var handleTitleBlur = function () {
        validateReportingYearTitle(reportingYearFields.title);
    };
    var handleCodeBlur = function () {
        validateReportingYearCode(reportingYearFields.code);
    };
    function resetOverlappedEndDateError() {
        if (state.fieldsErrorMessages.endDateError === overlappedDateError) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: "" }));
        }
    }
    function resetOverlappedStartDateError() {
        if (state.fieldsErrorMessages.startDateError === overlappedDateError) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: "" }));
        }
    }
    var handleStartDateBlur = function (event) {
        // Get the current value from the component
        var dateRangeEl = event.target;
        var currentStartValue = dateRangeEl.valueStart || dateRangeEl["value-start"] || "";
        // Update state with the current value
        if (currentStartValue !== reportingYearFields.startDate) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDate", startDate: currentStartValue }));
        }
        resetOverlappedEndDateError();
        validateReportingYearStartDate(currentStartValue, reportingYearFields.endDate);
    };
    var handleEndDateBlur = function (event) {
        // Get the current value from the component
        var dateRangeEl = event.target;
        var currentEndValue = dateRangeEl.valueEnd || dateRangeEl["value-end"] || "";
        // Update state with the current value
        if (currentEndValue !== reportingYearFields.endDate) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDate", endDate: currentEndValue }));
        }
        resetOverlappedStartDateError();
        validateReportingYearEndDate(currentEndValue, reportingYearFields.startDate);
    };
    var isDateRangeOverlap = function (existingStartDate, existingEndDate, newStartDate, newEndDate) {
        var existingStart = new Date(existingStartDate).getTime();
        var existingEnd = new Date(existingEndDate).getTime();
        var newStart = new Date(newStartDate).getTime();
        var newEnd = new Date(newEndDate).getTime();
        return ((existingStart <= newStart && newStart <= existingEnd) ||
            (existingStart <= newEnd && newEnd <= existingEnd) ||
            (newStart <= existingStart && existingStart <= newEnd) ||
            (newStart <= existingEnd && existingEnd <= newEnd));
    };
    var isValidDateFormat = function (dateString) {
        var pattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
        return pattern.test(dateString);
    };
    useEffect(function () {
        dispatch(__assign(__assign({}, defaultAction), { type: "resetFormInputs" }));
    }, [openReportingYearModalState]);
    useEffect(function () {
        dispatch(__assign(__assign({}, defaultAction), { type: "setReportingYearFields", updateReportingYear: updateReportingYear }));
    }, [updateReportingYear]);
    function validateAllFields() {
        if (reportingYearFields.title.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setTitleError", titleError: titleRequired }));
        }
        if (reportingYearFields.code.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setCodeError", codeError: codeRequired }));
        }
        if (reportingYearFields.startDate.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setStartDateError", startDateError: dateRequired }));
        }
        if (reportingYearFields.endDate.trim() === "") {
            dispatch(__assign(__assign({}, defaultAction), { type: "setEndDateError", endDateError: dateRequired }));
        }
        return (reportingYearFields.title &&
            reportingYearFields.code &&
            reportingYearFields.startDate &&
            reportingYearFields.endDate &&
            !fieldsErrorMessages.titleError &&
            !fieldsErrorMessages.codeError &&
            !fieldsErrorMessages.startDateError &&
            !fieldsErrorMessages.endDateError);
    }
    function getCsrfToken() {
        if (validateAllFields()) {
            var applyResultToken = function (result) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setToken", token: result.token }));
            };
            var onError = function (error) {
                // Log error in console for debugging
                console.log("API Error:", error);
                dispatch(__assign(__assign({}, defaultAction), { type: "setToken", token: null }));
            };
            sendRequest({
                uri: "/export/token",
                camelize: true
            }, applyResultToken, onError);
        }
        else {
            if (fieldsErrorMessages.titleError ||
                reportingYearFields.title.trim() === "") {
                focusField("#title-input");
            }
            else if (fieldsErrorMessages.codeError ||
                reportingYearFields.code.trim() === "") {
                focusField("#code-input");
            }
            else if (fieldsErrorMessages.startDateError ||
                reportingYearFields.startDate === "") {
                focusField("#date-range-input");
            }
            else if (fieldsErrorMessages.endDateError ||
                reportingYearFields.endDate === "") {
                focusField("#date-range-input");
            }
        }
    }
    function createUpdateReportingYear() {
        var formData = new FormData();
        formData.append("name", reportingYearFields.title);
        formData.append("code", reportingYearFields.code);
        if (reportingYearFields.reportingYearType) {
            formData.append("type", reportingYearFields.reportingYearType);
        }
        formData.append("start_date", formatDateUsToIso(reportingYearFields.startDate));
        formData.append("end_date", formatDateUsToIso(reportingYearFields.endDate));
        formData.append("_csrf_token", state.token ? state.token : "");
        var applyResult = function () {
            closeReportingYearModal();
            fetchReportingYears();
            setTimeout(function () {
                updateReportingYear
                    ? addSnackBar(reportingYearFields.title, "update")
                    : addSnackBar(reportingYearFields.title, "create");
            }, 1000);
        };
        var ryCreateUpdateUrl = "/sa/reporting_years";
        if (updateReportingYear) {
            ryCreateUpdateUrl = ryCreateUpdateUrl + "/".concat(updateReportingYear.uuid);
        }
        sendRequestWithPayload({
            uri: ryCreateUpdateUrl,
            body: formData
        }, applyResult);
    }
    function focusField(elementId) {
        var inputElement = document.querySelector(elementId);
        setTimeout(function () {
            inputElement.focus();
        }, 300);
    }
    useEffect(function () {
        if (state.token) {
            createUpdateReportingYear();
        }
    }, [state.token]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "input-margin", children: _jsx(WmInput, { label: titleLabel, type: "text", value: reportingYearFields.title, "required-field": true, "error-message": fieldsErrorMessages.titleError, info: fieldsErrorMessages.titleError ? "" : titleInfo, onInput: function (e) { return handleTitleChange(e); }, onBlur: handleTitleBlur, "character-limit": 50, id: "titleinput" }) }), _jsx("div", { className: "input-margin", children: _jsx(WmInput, { label: codeLabel, value: reportingYearFields.code, type: "text", "required-field": true, "error-message": fieldsErrorMessages.codeError, info: fieldsErrorMessages.codeError ? "" : codeInfo, onInput: function (e) { return handleCodeChange(e); }, onBlur: handleCodeBlur, "character-limit": 25, id: "code-input" }) }), _jsx("div", { className: "date-inputs", children: _jsx(WmDateRange, { "date-format": "mm/dd/yyyy", "label-start": startDateLabel, "label-end": endDateLabel, "required-field": true, "value-start": formatDateIsoToUs(reportingYearFields.startDate), "value-end": formatDateIsoToUs(reportingYearFields.endDate), "error-message": fieldsErrorMessages.startDateError ||
                        fieldsErrorMessages.endDateError, "invalid-start": !!fieldsErrorMessages.startDateError, "invalid-end": !!fieldsErrorMessages.endDateError, onInput: function (e) {
                        // Get the current values from the component using camelCase property names
                        var dateRangeEl = e.target;
                        var startValue = dateRangeEl.valueStart || "";
                        var endValue = dateRangeEl.valueEnd || "";
                        // Update state as user types for responsive feedback
                        dispatch(__assign(__assign({}, defaultAction), { type: "setStartDate", startDate: startValue }));
                        dispatch(__assign(__assign({}, defaultAction), { type: "setEndDate", endDate: endValue }));
                    }, onWmStartInputBlur: handleStartDateBlur, onWmEndInputBlur: handleEndDateBlur, onWmRangeSelection: handleRangeSelection, id: "date-range-input" }) })] }));
});
export default CreateReportingYearForm;
